import { getHeaders } from '../../utils/getter';
import { APP_ID } from '../../constant';

window.axiosConfig = {
  requestSuccessForPrefix: (requestObj) => {
    requestObj.headers = { ...requestObj.headers, ...getHeaders({ appId: APP_ID }) };
    return requestObj;
  },
};
